<template>
  <div id="vpp">
    <!-- 로더 -->
    <loader v-if="loaderActive"></loader>
    <!-- 페이지 -->
    <section class="vpp-banner">
      <div class="container">
        <div class="row text-center word-break-keep-all">
          <h1>비즈해줌과 함께<br>전력중개사업에 동참하세요.</h1>
<!--          <p>* 전력중개사업 발전소 소개만 해도 상품권 지급</p>-->
        </div>
        <div class="text-center">
          <button type="button" class="hz-btn-primary hz-btn-lg"
             @click.prevent="moveApplyForm()">참여하기</button>
        </div>
      </div>
    </section>
    <section id="vppWhat">
      <div class="container">
        <div class="text-center">
          <h2>전력중개사업이란 무엇인가요?</h2>
        </div>
        <div class="row box">
          <div class="text-center col-md-6">
            <img class="what_img" src="~@/assets/img/img-vpp-what.png" alt="전력중개사업이란">
          </div>
          <div class="col-md-6">
            <h3 class="title"><span class="number">01</span>소규모 전력중개사업</h3>
            <p class="detail-text">일정 규모의 신∙재생에너지, 전력저장장치(ESS), <br class="visible-xs">전기자동차에서 생산하고 <br class="hidden-xs">저장한 전력을<br class="visible-xs"> 전력중개사업자가 전력시장에서 거래하는 사업</p>
            <h3 class="title"><span class="number">02</span>전력·공급인증서 거래 대행</h3>
            <p class="detail-text">발전사업자가 전력중개사업자(해줌)에게 전력 및<br class="visible-xs"> 공급인증서(REC)<br class="hidden-xs"> 거래 권한을 위임하여 <br class="visible-xs">소규모전력중개 시장에서 거래를 대행하는 사업</p>
          </div>
        </div>
      </div>
    </section>
    <section id="vppWhy">
      <div class="container">
        <div class="text-center">
          <h2>왜 전력중개사업에<span class="xs-block"> 참여해야 하나요?</span></h2>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-push-1 col-md-5 col-lg-push-2 col-lg-4">
            <div class="text-center">
              <span class="number_why">01</span>
              <p class="orange_line"></p>
              <div class="hidden-xs"><img class="img_why" src="~@/assets/img/img-vpp-reason-01.png"></div>
              <div class="visible-xs"><img class="img_why" src="~@/assets/img/img-vpp-reason-01-sm.png"></div>
              <h3>전력 판매 수익 증대</h3>
              <p>전력거래소를 통한 <span class="bold">SMP(전력판매단가)</span><br>시간대별 판매로 수익 증가</p>
              <span class="sub_txt">한전에서 전력거래소로 변경 시</span>
              <p class="space">해줌에서 더 유리한 가격에 <span class="bold">REC(공급인증서)</span> 판매 가능</p>
            </div>
          </div>
          <div class="col-xs-12 col-md-push-1 col-md-5 col-lg-push-2 col-lg-4">
            <div class="small">
              <div class="text-center">
                <span class="number_why">02</span>
                <p class="orange_line"></p>
                <div class="hidden-xs"><img class="img_why" src="~@/assets/img/img-vpp-reason-02.png"></div>
                <div class="visible-xs"><img class="img_why" src="~@/assets/img/img-vpp-reason-02-sm.png"></div>
                <h3>시설 관리 부담 감소</h3>
                <p class="hidden-xs">해줌의 인공지능(AI) 기반 <br> 유지∙관리 서비스를 통한<br>설비 이상감지 가능</p>
                <p class="visible-xs">해줌의 인공지능(AI) 기반 유지∙관리 <br>서비스를 통한 설비 이상감지 가능</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="whyHz">
      <div class="container">
        <div class="text-center">
          <h2>왜 해줌과 함께해야 할까요?</h2>
        </div>
        <div class="row text-center">
          <div class="col-xs-12 col-md-push-1 col-md-10 col-lg-push-2 col-lg-8">
            <div class="grey_box">
              <h3 class="title">준비된<span class="orange">&nbsp;제1호&nbsp;</span>중개사업자</h3>
              <div class="row text-left">
                <div class="list hidden-xs">
                  <div class="col-sm-push-2 col-sm-10"><p class="badge">2019</p><a class="sub_txt" target="_blank" href="http://www.todayenergy.kr/news/articleView.html?idxno=211144" style="text-decoration: underline;">제1호 전력중개사업자</a></div>
                  <div class="col-sm-push-2 col-sm-10"><p class="badge" style="vertical-align: top;">2018</p><span class="sub_txt" style="display:inline-block; width: 379px; height: 44px;">예비 중개사업자 중 유일한 전력중개시장 상용화 기술 관련<br style="line-height:1.38">산업통상자원부 연구과제 참여</span></div>
                  <div class="col-sm-push-2 col-sm-10" style="margin-top: 10px;"><p class="badge">2018</p><a class="sub_txt" target="_blank" href="http://www.todayenergy.kr/news/articleView.html?idxno=204152" style="text-decoration: underline;">유럽 최대 가상발전소 운영사 獨넥스트크라프트베르케와 MOU</a></div>
                  <div class="col-sm-push-2 col-sm-10"><p class="badge">2016</p><a class="sub_txt" target="_blank" href="http://www.todayenergy.kr/news/articleView.html?idxno=118452" style="text-decoration: underline;">소규모 전력중개사업 시범사업자 선정 (구 이든스토리)</a></div>
                </div>
                <div class="list visible-xs">
                  <div class="row">
                    <div class="col-xs-4 text-right"><div class="badge">2019</div></div>
                    <div class="col-xs-8"><a class="sub_txt" target="_blank" href="http://www.todayenergy.kr/news/articleView.html?idxno=211144" style="text-decoration: underline;">제1호 전력중개사업자</a></div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 text-right"><div class="badge">2018</div></div>
                    <div class="col-xs-8"><span class="sub_txt">예비 중개사업자 중 유일한 전력중개시장 상용화 기술 관련<br>산업통상자원부 연구과제 참여</span></div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 text-right"><div class="badge">2018</div></div>
                    <div class="col-xs-8"><a class="sub_txt" target="_blank" href="http://www.todayenergy.kr/news/articleView.html?idxno=204152" style="text-decoration: underline;">유럽 최대 가상발전소 운영사 <br>獨넥스트크라프트베르케와 MOU</a></div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 text-right"><div class="badge">2016</div></div>
                    <div class="col-xs-8"><a class="sub_txt" target="_blank" href="http://www.todayenergy.kr/news/articleView.html?idxno=118452" style="text-decoration: underline;">소규모 전력중개사업 <br>시범사업자 선정 (구 이든스토리)</a></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grey_box rounded">
              <h3 class="title"><span class="js-counter service-number orange" data-comma-separated="true">{{ plantsCount | intcomma }}</span><span class="orange">개&nbsp;</span>발전소의&nbsp;<span class="xs-block">풍부한 자원</span></h3>
              <p class="sub_txt">전국에 골고루 분포한 태양광 발전소에서 기술력 검증 및 풍부한 자원 관리</p><p class="lightgrey_txt">*<span id="nowYear">{{ new Date().getFullYear() }}</span>년 <span id="nowMonth">{{ new Date().getMonth() }}</span>월 기준</p>
            </div>
            <div class="grey_box rounded">
              <h3 class="title inline">국제적 재생에너지 연구소와 동등한 수준의<span class="xs-block"></span></h3>
              <p class="title">발전량 예측기술 보유</p>
              <div class="row">
                <div class="col-xs-push-1 col-xs-10 col-sm-5 col-lg-push-1 col-lg-5">
                  <div class="row">
                    <div class="align_md">
                      <p class="sub_title">태양광 발전량 예측 기술</p>
                      <p class="desc inline">1시간 뒤, 내일 등 미래 발전량을 예측하여 전력망</p>
                      <p class="desc inline">안정화에 도움을 주는 기술</p>
                    </div>
                    <div class="align_md wh_badge"><b>특허등록</b>제10-1808047호</div>
                  </div>
                </div>
                <div class="col-xs-push-1 col-xs-10 col-sm-5 col-md-5 col-lg-push-1 col-lg-5">
                  <div class="row">
                    <div class="align_md">
                      <p class="sub_title">태양광 발전소 이상감지 기술</p>
                      <p class="desc inline">발전량, 날씨 등 데이터를 통한 빠른 발전소 이상</p>
                      <p class="desc inline">감지로 손실을 최소화 하는데 도움을 주는 기술</p>
                    </div>
                    <div class="align_md wh_badge"><b>특허등록</b>제10-1775065호</div>
                  </div>
                </div>
                <div class="col-xs-push-1 col-xs-10 col-sm-5 col-md-5 col-lg-push-1 col-lg-5">
                  <div class="row">
                    <div class="align_md">
                      <p class="sub_title">녹색기술인증 이상감지 시스템</p>
                      <p class="desc inline">기상위성(천리안)을 활용한 태양광 발전소 발전량</p>
                      <p class="desc inline">예측 및 이상감지</p>
                    </div>
                    <div class="align_md wh_badge" style="width: 128px;"><b>인증</b>GT-18-00521호</div>
                  </div>
                </div>
                <div class="col-xs-push-1 col-xs-10 col-sm-5 col-md-5 col-lg-push-1 col-lg-5">
                  <div class="row">
                    <div class="align_md">
                      <p class="sub_title">산업통상자원부 연구과제 참여</p>
                      <p class="desc inline">소규모 분산자원 중개시장서비스 상용화 기술</p>
                      <p class="desc inline">개발 및 실증 (인센티브 도입 연구 포함)</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grey_box rounded">
              <h3 class="title">한국과 UN이 주목한<span class="orange block">&nbsp;1위&nbsp;브랜드</span></h3>
              <div class="row text-left">
                <div class="list hidden-xs">
                  <div class="col-sm-push-2 col-sm-10"><p class="badge">2018</p><span class="sub_txt">2018 한국 브랜드 대상 1위 수상</span></div>
                  <div class="col-sm-push-2 col-sm-10"><p class="badge">2018</p><span class="sub_txt">부산 스마트시티 1번가 공모전 최우수상 수상</span></div>
                  <div class="col-sm-push-2 col-sm-10"><p class="badge">2018</p><span class="sub_txt">UN-서울시 도시혁신챌린지 우수상 수상</span></div>
                  <div class="col-sm-push-2 col-sm-10"><p class="badge">2018</p><span class="sub_txt">과학기술정보통신부 ICT 유망기업 K-Global 300 선정</span></div>
                  <div class="col-sm-push-2 col-sm-10"><p class="badge">2017</p><span class="sub_txt">제12회 기상산업대상 한국기상산업기술 원장상 수상</span></div>
                  <div class="col-sm-push-2 col-sm-10"><p class="badge">2014</p><span class="sub_txt">대한민국 환경에너지 경영부문 대상 (산업통상자원부 장관상)</span></div>
                </div>
                <div class="list visible-xs">
                  <div class="row">
                    <div class="col-xs-4 text-right"><div class="badge">2018</div></div>
                    <div class="col-xs-8"><span class="sub_txt">2018 한국 브랜드 대상 1위 수상</span></div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 text-right"><div class="badge">2018</div></div>
                    <div class="col-xs-8"><span class="sub_txt">부산 스마트시티 1번가 공모전<br>최우수상 수상</span></div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 text-right"><div class="badge">2018</div></div>
                    <div class="col-xs-8"><span class="sub_txt">UN-서울시 도시혁신챌린지 우수상 수상</span></div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 text-right"><div class="badge">2018</div></div>
                    <div class="col-xs-8"><span class="sub_txt">과학기술정보통신부 ICT 유망기업 <br>K-Global 300 선정</span></div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 text-right"><div class="badge">2017</div></div>
                    <div class="col-xs-8"><span class="sub_txt">제12회 기상산업대상<br>한국기상산업기술 원장상 수상</span></div>
                  </div>
                  <div class="row">
                    <div class="col-xs-4 text-right"><div class="badge">2014</div></div>
                    <div class="col-xs-8"><span class="sub_txt">대한민국 환경에너지 경영부문 대상<br>(산업통상자원부 장관상)</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="vppApply">
      <div class="container">
        <div class="row">
          <div class="contents col-md-offset-3 col-md-6 col-xs-12">
            <div class="contact-header text-center">
              <h2 class="title">제휴 및 문의</h2>
              <h4 class="contact-sub-title">사업제안 또는 문의내용을 작성해주시면 <br>전화 또는 이메일로 답변드립니다.</h4>
            </div>
            <form class="contact-form" @submit.prevent="onSubmit">
              <div id="scrollForm" class="form-group">
                <div class="col-md-4 col-xs-12">
                  <label>회사명</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         maxlength="40"
                         data-vv-name="company"
                         v-validate="{required: true}"
                         v-model="data['company_name']"
                         placeholder="예) 해줌"
                         :readonly="user.id">
                  <p class="is-invalid-text">{{ errors.first('company') }}</p>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-4 col-xs-12">
                  <label>담당자명</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         maxlength="40"
                         data-vv-name="name"
                         v-validate="{required: true}"
                         v-model="data['name']"
                         placeholder="예) 홍길동">
                  <p class="is-invalid-text">{{ errors.first('name') }}</p>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-4 col-xs-12">
                  <label>담당자 연락처</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input-phone :class="['hz-input-default', 'hz-input-lg', {'is-invalid': errors.first('contact')}]"
                               data-vv-name="contact"
                               v-validate="{required: true, min:9, max:16}"
                               v-model="data['contact']"
                               :placeholder="'예) 010-0000-0000'"></input-phone>
                  <p class="is-invalid-text">{{ errors.first('contact') }}</p>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-4 col-xs-12">
                  <label>담당자 이메일</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         maxlength="50"
                         data-vv-name="email"
                         v-validate="{required: true, email: true}"
                         v-model="data['email']"
                         :placeholder="'예) haezoom@haezoom.com'">
                  <p class="is-invalid-text">{{ errors.first('email') }}</p>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-4 col-xs-12">
                  <label>협력 내용</label>
                </div>
                <div class="col-md-8 col-xs-12">
                  <textarea rows="10"
                            class="hz-input-default"
                            style="width: 100%; padding: 16px;"
                            data-vv-name="inquiryMemo"
                            v-validate="{required: true}"
                            v-model="data['content']"
                            :placeholder="'협력내용을 적어주세요'">

                  </textarea>
                  <p class="is-invalid-text">{{ errors.first('inquiryMemo') }}</p>
                </div>
              </div>
              <div class="form-group" v-if="!user.id">
                <p style="margin-bottom:0;">
                  <label class="hz-checkbox sub-check-agree">
                    <b>전체동의</b>
                    <input type="checkbox"
                           class="agree_all"
                           v-model="data['agree_all']"
                           @change="checkAgree('all')">
                    <span class="checkmark"></span>
                  </label>
                </p>
                <p style="margin-bottom:0;">
                  <label class="hz-checkbox sb-check-agree">
                    <a href="https://biz.haezoom.com/media/terms/bizhaezoom_terms_2020.pdf" target="_blank">이용약관</a> 및 <a href="https://biz.haezoom.com/privacy/" target="_blank"> 개인정보 취급방침</a> 동의 (필수)
                    <input type="checkbox"
                           class="agree_usage checkbox-list"
                           v-model="data['agree_usage']"
                           @change="checkAgree()">
                    <span class="checkmark"></span>
                  </label>
                </p>
                <p style="margin-bottom:0;">
                  <label class="hz-checkbox sub-check-agree">
                    태양광 정보 뉴스레터, 프로모션 등 수신 (선택)
                    <input type="checkbox"
                           class="agree_promotion"
                           v-model="data['agree_promotion']"
                           @change="checkAgree()">
                    <span class="checkmark"></span>
                  </label>
                </p>
              </div>
              <button type="submit" class="hz-btn-primary hz-btn-lg col-xs-12" style="width: 100%;">문의하기</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import Loader from 'common/components/Loader'
  import InputPhone from 'common/components/InputPhone'
  import DropDownList from 'common/components/DropDownList'
  import {mapGetters, mapActions} from 'vuex'
  import api from '@/api/onm'

  export default {
    name: 'vpp',
    data: function () {
      return {
        loaderActive: false,
        plantsCount: '-',
        data: {
          company_name: '',
          name: '',
          contact: '',
          email: '',
          content: '',
          agree_all: false,
          agree_usage: false,
          agree_promotion: false,
          contact_route: '비즈해줌사이트'
        }
      }
    },
    components: {
      Loader,
      InputPhone,
      DropDownList,
      mapGetters
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    watch: {
      'user': {
        handler: function (val) {
          if (typeof val.id !== 'undefined') {
            this.init()
          }
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      init: function () {
        const user = this.user

        // 로그인한 유저 일 경우, 기본값을 설정해준다.
        if (typeof user.id !== 'undefined') {
          this.data = {
            company_name: user.comp_name,
            name: user.pic_name,
            contact: user.pic_contact,
            email: user.pic_email,
            content: ''
          }
        }
      },
      getPlantsCount: function () {
        const vm = this

        // 등록된 발전소수를 불러온다
        api.getPlantsCount(response => {
          if (response.error) {
            console.log('fail get plants count!', response)
          } else {
            // 데이터를 제대로 불러온 경우, 발전소수를 넣어준다
            vm.plantsCount = response.result
          }
        })
      },
      checkAgree: function (type = '') {
        const vm = this
        const data = vm.data

        // 전체선택 체크박스가 클릭되었을 경우
        if (type === 'all') {
          vm.data.agree_usage = data.agree_all
          vm.data.agree_promotion = data.agree_all
        } else {
          // 이용약관 및 프로모션 동의여부 상태에 따른 전체동의 상태 처리
          vm.data.agree_all = data.agree_usage && data.agree_promotion
        }
      },
      moveApplyForm: function () {
        const el = document.getElementById('scrollForm')
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      },
      onSubmit: function () {
        const vm = this
        vm.$validator.validateAll()
        // validation 완료 후 문의하기 API 호출
        vm.$nextTick(function () {
          if (!vm.errors.any()) {
            vm.applyVpp()
          }
        })
      },
      applyVpp: function () {
        const vm = this
        const data = $.extend(true, {}, vm.data)

        if (!data.agree_usage && !vm.user.id) {
          return alert('이용약관 및 개인정보 취급방침 동의는 필수입니다.')
        }

        // 로더 활성화
        vm.loaderActive = true

        // 전력중개사업 문의 신청하기
        api.applyVpp(data, response => {
          if (response.error) {
            // 로더 비활성화
            vm.loaderActive = false
            vm.showToastMessage('전력중개사업 문의실패')
            console.log(response.source)
          } else {
            // 신청이 완료되었을 경우, 문의 내용 및 동의 내용 초기화
            vm.data['content'] = ''
            vm.data['agree_all'] = false
            vm.data['agree_usage'] = false
            vm.data['agree_promotion'] = false

            // 로더 비활성화
            vm.loaderActive = false
            vm.showToastMessage('전력중개사업 문의완료')
          }
        })
      }
    },
    created: function () {
      const vm = this
      const token = localStorage.getItem('_t')
      // 관리중인 발전소 수를 불러온다
      vm.getPlantsCount()
      // 토큰여부 확인.
      if (token) {
        // 토큰 검증 및 갱신 성공 시 화면렌더.
        vm.$store.dispatch('inspectToken', token).then((response) => {
          vm.init()
        })
      }
    },
    beforeDestroy: function () {
      kendo.destroy(document.body)
    }
  }
</script>

<style lang="scss" scoped>
  #vpp {
    .hz-btn-lg {
      width: 167px;
      margin-top: 46px;
      @media (max-width: 320px) {
        height: 40px;
      }
    }
    .vpp-banner {
      position: relative;
      padding: 116px 0;
      background-image: url("../assets/img/bg-vpp-banner.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 100%;

      @media (max-width: 767px) {
        height: 364px;
        padding-top: 90px;
      }
      h1 {
        margin: 0;
        padding: 0 16px;
        font-size: 48px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.25;
        letter-spacing: -2.9px;
        color: $hzc-white;

        @media (max-width: 991px) {
          font-size: 36px;
        }
        @media (max-width: 767px) {
          font-size: 28px;
        }
      }
      p {
        margin: 24px 0 0 0;
        color: $orange;
      }
    }

    .container {
      padding: 0 16px;
    }

    .contents {
      padding: 0;
      margin-top: 96px;
      margin-bottom: 96px;
      @media (max-width: 767px) {
        margin-top: 48px;
        margin-bottom: 48px;
      }
    }

    .contact-title, .contact-sub-title {
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: -1px;
      color: $header-color;
    }

    .contact-title {
      font-size: 24px;
    }

    .contact-sub-title {
      font-size: 14px;
    }

    .contact-form {
      width: 100%;
      height: 100%;
      overflow: hidden;
      margin: 40px 0;

      .form-group {
        width: 100%;
        overflow: hidden;
        margin-bottom: 16px;

        .col-md-4, .col-md-8 {
          padding: 0;

          >label {
            margin: 0;
            font-size: 14px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 48px;
            letter-spacing: -0.8px;
            text-align: left;
            color: $font-color;
            @media (max-width: 767px) {
              line-height: 32px;
            }
          }

          >input {
            width: 100%;
          }
        }
      }
    }

    .text-area {
      resize: none;
      width: 100%;
      height: 122px;
      padding: 8px;
      border: solid 1px #e9ecef;
    }

    button {
      margin-top: 30px;
      height: 48px;
    }

    .drop-down-list {
      border: solid 1px #e9ecef
    }
  }
  #vppWhat, #vppWhy {
    h2 {
      font-size: 36px;
      line-height: 1;
      letter-spacing: -0.3px;
      font-weight: bold;
    }
    h3 {
      font-size: 28px;
      font-weight: bold;
      line-height: 1;
    }
    .number_why {
      display: block;
      margin-top: 50px;
      margin-bottom: 8px;
      font-weight: normal;
      color: #26507a;
      font-size: 16px;
    }
    .orange_line {
      width: 17px;
      height: 3px;
      margin: 0 auto;
      background-color: #ff7133;
    }
  }
  #vppWhat {
    padding: 110px 0;
    .box {
      margin-top: 60px;
    }
    img {
      max-width: 436px;
      height: auto;
    }
    h3 {
      margin-top: 32px;
      font-size: 20px;
      font-weight: bold;
      line-height: 1;
      .number {
        padding-right: 8px;
        color: #adb5bd;
      }
    }
    .detail-text{
      padding-bottom: 14px;
      font-size: 16px;
      line-height: 1.63;
      word-break: break-all;
    }

  }
  #vppWhy {
    width: 100%;
    padding: 110px 0;
    background-color: #f8f9fa;
    .img_why {
      margin-top: 40px;
      max-width: 100px;
      height: auto;
    }
    h3 {
      margin-top: 32px;
      margin-bottom: 14px;
    }
    p {
      font-size: 16px;
      line-height: 1.38;
      margin-bottom: 8px;
    }
    .space {
      margin-top: 16px;
    }
    .bold {
      font-weight: bold;
    }
    .sub_txt {
      line-height: 2;
      font-size: 12px;
      color: #adb5bd;
    }
  }

  #whyHz {
    width: 100%;
    padding: 110px 0;
    >.container {
      overflow: hidden;
    }
    h2 {
      margin-bottom: 60px;
      font-size: 36px;
      font-weight: bold;
      line-height: 1;
      letter-spacing: -0.3px;
    }
    .grey_box {
      margin-bottom: 16px;
      padding-top: 40px;
      padding-bottom: 40px;
      background-color: #f8f9fa;
      border-radius: 8px;
      >.title {
        font-size: 28px;
        font-weight: bold;
        .orange {
          color: #ff7133;
        }
      }
      .title {
        line-height: 1.2;
        margin-bottom: 8px;
      }
      .sub_txt {
        font-size: 16px;
        line-height: 1.38;
        color: #495057;
      }
      .lightgrey_txt {
        margin-left: 8px;
        font-size: 12px;
        color: #adb5bd;
      }
      .badge {
        font-weight: normal;
        margin-bottom: 8px;
        height: 22px;
        line-height: 1.4;
        border-radius: 13px;
        background-color: $hzc-blue-10;
      }
      .wh_badge {
        width: 154px;
        height: 22px;
        border-radius: 13px;
        background-color: #ffffff;
        color: #868e96;
        font-size: 12px;
        line-height: 1.9;
        text-align: center !important;
        margin-top: 10px;
      }
      .wh_badge b {
        padding-right: 4px;
      }
      .grey_txt {
        font-size: 14px;
        font-weight: bold;
        line-height: 1.43;
        letter-spacing: -0.1px;
        color: #868e96;
      }
      .sub_title {
        margin-top: 40px;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.25;
        letter-spacing: -0.1px;
        color: #ff7133;
      }
      .list {
        margin-top: 37px;
        .sub_txt {
          margin-left: 10px;
          line-height: 1;
          letter-spacing: -0.1px;
        }
      }
    }
  }
  #vppApply {
    background-color: #f8f9fa;
    .title {
      font-size: 32px;
      font-weight: bold;
      @media (max-width: 767px) {
        font-size: 24px;
      }
    }
    .contact-sub-title {
      font-size: 14px;
      line-height: 1.43;
      letter-spacing: -0.8px;
    }
  }
  @media (min-width: 992px) and (max-width: 3000px) {
    .lg_inline{
      display: inline-block;
    }
    .pr-6 { padding-right: 6px;}
    .pl-6 {padding-left: 6px;}
    #intro {
      height: 362px;
    }
    #vppWhy {
      .col-md-5.col-lg-4 {
        padding-left: 6px;
        padding-right: 6px;
      }
    }
    .etc_tit {
      width: 10%;
      display: inline-block;
    }
    .etc_input {
      width: 89%;
      display: inline-block;
    }
  }
  @media (min-width: 769px) and (max-width: 992px) {
    #intro {
      height: 362px;
    }
    .etc_tit {
      width: 66px;
      display: inline-block;
    }
    .etc_input {
      /* 구식 브라우저를 위한 대비책(fallback) */
      width : -webkit-calc(100% - 70px); /* for Chrome, Safari */
      width :    -moz-calc(100% - 70px); /* for Firefox */
      width :         calc(100% - 70px); /* for IE */
      display: inline-block;
    }
  }
  @media (max-width: 992px) {
    .sub_tit {
      text-align: left;
    }
    .sub-news.mb-24 {
      text-align: left;
      margin-bottom: 24px;
    }
    .sub-news>a {}
    #vppWhat {
      h3 {
        text-align: center;
      }
      .detail-text {
        text-align: center;
      }
    }
  }
  @media (min-width: 769px) and (max-width: 3000px) {
    .lg-block {
      display: block;
    }
    #whyHz {
      .grey_box {
        .align_md {
          text-align: left;
        }
        .desc {
          width: 280px;
          white-space: nowrap;
        }
        .grey_txt {
          white-space: nowrap;
        }
      }
    }
  }
  @media (max-width: 767px) {
    .xs-block {
      display: block;
    }
    .inline {
      display: inline;
    }
    .block {
      display: block;
    }

    #vppWhat {
      padding: 40px 0;
      .box {
        margin-top: 35px;
      }
      h2 {
        line-height: 1.25;
        font-size: 24px;
        word-break: keep-all;
      }

      h3.title {
        font-size: 16px;
      }

      .detail-text {
        font-size: 14px;
      }

      .what_img {
        max-width: 290px;
      }
    }

    #vppWhy {
      padding: 40px 0;
      h2 {
        line-height: 1.25;
        font-size: 24px;
        word-break: keep-all;
      }
      h3 {
        font-size: 20px;
        margin-top: 20px;
      }
      p {
        font-size: 14px;
      }
      .space {
        word-break: keep-all;
      }
      .small {
        height: 208px;
      }
      .number_why {
        margin-top: 35px;
      }
      .img_why {
        max-width: 60px;
        margin-top: 24px;
      }
    }
    #whyHz {
      padding: 40px 0;
      h2 {
        line-height: 1.25;
        font-size: 24px;
        word-break: keep-all;
        margin-bottom: 17px;
      }
      .grey_box {
        padding: 24px 12px;
        > .title {
          word-break: keep-all;
        }
        h3.title, p.title {
          font-size: 20px;
        }
        .sub_title {
          margin-top: 24px;
        }
        span.sub_txt {
          word-break: keep-all;
          font-size: 14px;
        }
        a.sub_txt {
          font-size: 14px;
          word-break: keep-all;
        }
        .desc {
          word-break: keep-all;
        }
        .wh_badge {
          margin: 10px auto;
        }
        .list {
          margin-top: 16px;
          .row {
            margin-bottom: 8px;
          }
          .col-xs-1 {
            width: 45px;
            padding-right: 0px;
            margin-right: 20px;
          }
          .col-xs-10 {
            padding-left: 0px;
          }
          .sub_txt {
            font-size: 14px;
            margin-left: 0px;
          }
        }
        .list.visible-xs {
          .col-xs-8 {
            padding-left: 0px;
            word-break: keep-all;
          }
        }
        .grey_txt {
          font-size: 12px;
          line-height: 1.5;
          letter-spacing: -0.1px;
        }
        .research {
          letter-spacing: -0.5px;
        }
        .badge_box {
          font-size: 12px;
          .badge {
            line-height: 1.33;
          }
          .sub_txt {
            display: inline-block;
          }
        }
      }
    }
  }
  @media (max-width: 380px) {
    #whyHz {
      .list.visible-xs {
        .col-xs-4 {
          width: 25%;
        }
        .col-xs-8 {
          width: 75%;
          padding-left: 10px;
        }
      }
    }
    .etc_input {
      /* 구식 브라우저를 위한 대비책(fallback) */
      width : -webkit-calc(100% - 70px); /* for Chrome, Safari */
      width :    -moz-calc(100% - 70px); /* for Firefox */
      width :         calc(100% - 70px); /* for IE */
      display: inline-block;
    }
  }
  @media (max-width: 300px) {
    #intro h1 {
      font-size: 25px;
    }
    .img_why {
      width: 60px;
    }
    #vppWhat {
      .detail-text {
        font-size: 12px;
      }
      .what_img {
        width: 100%;
      }
    }
    #whyHz {
      .grey_box {
        .sub_txt, .desc {
          font-size: 12px;
        }
        .grey_txt {
          font-size: 11px;
        }
        .list {
          br { display: none;}
          .sub_txt {
            font-size: 12px;
          }
        }
        .list.visible-xs {
          .col-xs-4 {
            width: 20%;
          }
          .col-xs-8 {
            width: 75%;
            padding-left: 10px;
          }
        }
      }
    }
  }
  @media (max-width: 527px) {
    #whyHz {
      .grey_box {
        .list {
          .col-xs-10 {
            width: 70%;
            padding-left: 0px;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Vpp.vue